<template>
  <v-theme-provider>
    <base-section
      id="commissioner"
      space="40"
    >
      <v-container>
        <v-row justify="center">
          <v-col cols="12">
            <base-section-heading title="Dewan Komisaris" />
            <base-body space="0">
               <v-container fluid>
                <v-row dense>
                  <v-col
                    v-for="card in cards"
                    :key="card.name"
                    md="4"
                    xs="12"
                  >
                    <div 
                      data-aos="fade-in"
                      data-aos-delay="50"
                      data-aos-duration="1000"
                      data-aos-easing="ease-in-out"
                      data-aos-mirror="true"
                      data-aos-once="true"
                      data-aos-anchor-placement="top-center">
                    <v-hover v-slot="{ hover }">
                    <v-card
                    outlined>
                      <v-img
                        :src="require(`@/assets/${card.src}`)"
                        class="white--text align-end"
                        height="350px"
                        :gradient="hover ? '' : 'to top right, rgba(100,115,201,.33), rgba(25,32,72,.7)'"
                        :alt="card.name"
                      >
                      <v-card-title class="body-1" v-text="card.name" v-if="hover===false"></v-card-title>
                      </v-img>
                      <v-card-actions>
                        <div  v-if="hover" class="caption" v-html="card.detail"></div>
                        <div v-else>{{ card.title }}</div>
                      </v-card-actions>
                    </v-card>
                    </v-hover>
                    </div>
                  </v-col>
                </v-row>
              </v-container>
            </base-body>
          </v-col>
        </v-row>
      </v-container>
    </base-section>
  </v-theme-provider>
</template>

<script>
  export default {
    name: 'SectionCommissioner',
    data: () => ({
            posts: [],
            cards: [
              { name: 'Bahroji', title: 'Komisaris Utama', src: 'Bahrodji-nologo.png',detail: '<strong>Drs. H. Bahroji, M.M.</strong> Lahir di Tegal, 4 Desember 1960. Menjabat sebagai Komisaris Utama sejak tahun 2018 dan pemegang 9,52% saham di PT Asuransi Takaful Umum. Beliau meraih gelar S2 di bidang Manajemen dari Universitas Jenderal Soedirman, Purwokerto. Saat ini, Beliau juga aktif sebagai Wakil Bendahara Umum di Koperasi Simpan Pinjam JASA' },
              { name: 'Ahmad Subagyo', title: 'Komisaris Independen', src: 'AhmadSubagyo-nologo.png', detail: '<strong>DR. Ahmad Subagyo, S.E., M.M., CRBD.</strong> Lahir di Pekalongan, 12 Februari 1972. Meraih gelar S1 di Fakultas Ekonomi dan S2 di bidang Manajemen dari Universitas Jenderal Soedirman, Purwokerto. Kemudian melanjutkan pendidikan S3 di bidang Pengkajian Ekonomi Islam di UIN Syarif Hidayatullah Jakarta. Beliau menjabat sebagai Komisaris PT Asuransi Takaful Umum sekaligus sebagai Anggota Komite Nominasi dan Remunerasi serta Anggota Komite Audit.' },
              { name: 'Ricky Avicenna', title: 'Komisaris Independen', src: 'RickyAvicenna-nologo.png', detail: '<strong>Ricky Avicenna, S.E., QIP, AAAIK, AIIS, CRMP.</strong> Lahir di Langsa, 18 Mei 1979. Menempuh pendidikan S1 Fakultas Ekonomi Universitas Indonesia pada tahun 2001. Beliau menjabat sebagai Komisaris Independen PT Asuransi Takaful Umum sejak tahun 2018 sekaligus sebagai Ketua Komite Pemantau Risiko dan Anggota Komite Nominasi dan Remunerasi PT Asuransi Takaful Umum.' },
            ],
        }),
  }
</script>
npm 